// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@nuxt/postcss8/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".booking-dimension-form{display:grid;grid-template-columns:1fr;grid-column-gap:20px;grid-row-gap:30px;width:100%}@media screen and (min-width: 992px){.booking-dimension-form{grid-template-columns:repeat(6, 1fr) !important}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
